import { Link } from "react-router-dom";
import { event as gaEvent } from "@/lib/gtag";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#1A1A1A] pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6">
        {/* 상호명 */}
        <p className="text-white font-bold text-lg mb-5">솔버스</p>

        {/* 네비게이션 */}
        <nav className="flex items-center gap-5 mb-8">
          {[
            { label: '홈', href: '#', external: false },
            { label: '무료체험', href: '#how', external: false },
            { label: '가격', href: '#pricing', external: false },
            { label: '문의하기', href: 'http://pf.kakao.com/_BLxhxhX/chat', external: true },
          ].map((link) => (
            <a
              key={link.label}
              href={link.href}
              {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              className="text-sm text-white/70 hover:text-[#C9A96E] transition-colors font-light cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* 사업자 정보 */}
        <div className="space-y-2 mb-8">
          {[
            '사업자등록번호 | 561-07-03011',
            '대표 | 정홍기',
            '주소 | 서울특별시 성동구 무학봉 16길 22, 3층',
            '통신판매업 신고번호 | 2025-서울성동-1234',
            '이메일 | solvers.official@gmail.com',
            '전화번호 | 010-2940-2884',
          ].map((info) => (
            <p key={info} className="text-sm text-white/50 font-light">
              {info}
            </p>
          ))}
        </div>

        {/* 소셜 아이콘 */}
        <div className="flex items-center gap-4 mb-10">
          {[
            { icon: 'ri-instagram-line', href: 'https://www.instagram.com/bomnal_ai_wedding?igsh=MWdkazZ4Y3FldHV0cg%3D%3D&utm_source=qr' },
            { icon: 'ri-threads-line', href: 'https://www.threads.com/@bomnal_ai_wedding?igshid=NTc4MTIwNjQ2YQ==' },
          ].map((s) => (
            <a
              key={s.icon}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => gaEvent('click_social', { platform: s.icon.includes('instagram') ? 'instagram' : 'threads', location: 'footer' })}
              className="text-white/60 hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer"
            >
              <i className={`${s.icon} text-2xl`}></i>
            </a>
          ))}
        </div>

        {/* 하단 */}
        <div className="pt-8 border-t border-white/10">
          <p className="text-xs text-white/30 font-light mb-3">
            Copyright 2025. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <Link to="/terms" className="text-xs text-white/40 hover:text-[#C9A96E] transition-colors font-light cursor-pointer">
              서비스 이용약관
            </Link>
            <span className="text-white/20">|</span>
            <Link to="/privacy" className="text-xs text-white/40 hover:text-[#C9A96E] transition-colors font-light cursor-pointer">
              개인정보처리방침
            </Link>
            {/* <span className="text-white/20">|</span>
            <a href="#" className="text-xs text-white/40 hover:text-[#C9A96E] transition-colors font-light cursor-pointer">
              회원탈퇴
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
